export function SignIn(token, {isNV, isV}) {

  if (token) {
    localStorage.setItem("jwt", token);
  }

  if (isV) {
    localStorage.setItem("isV", "1");
  }

  if (isNV) {
    localStorage.setItem("isNV", "1");
  }
}

export function SignOut(token) {
  localStorage.removeItem("jwt");
  localStorage.removeItem("isV");
  localStorage.removeItem("isNV");
  localStorage.removeItem("isF");

}
